import React from "react";
import { useTranslation } from "react-i18next";

const ClaimInfo = ({ sliderOrder }) => {
  const { t } = useTranslation();

  return (
    <div>
      <table className="border-collapse border border-slate-400 w-full mt-4">
        {sliderOrder && (
          <>
            <tr>
              <td className="border border-slate-300 p-4">{t("status")}</td>
              <td className="border border-slate-300 p-4">
                <div>{sliderOrder.status}</div>
              </td>
            </tr>

            {sliderOrder.trackingUrl && (
              <tr>
                <td className="border border-slate-300 p-4">{t("Tracking Url")}</td>
                <td className="border border-slate-300 p-4">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={sliderOrder.trackingUrl}
                    className="underline text-blue-500"
                  >
                    {sliderOrder.trackingUrl}
                  </a>
                </td>
              </tr>
            )}

            {(sliderOrder.driver_info ) && (
              <>
                {sliderOrder.driver_info.name && (
                  <tr>
                    <td className="border border-slate-300 pl-4 border-b-0">Delivery Guy</td>
                    <td className="border border-slate-300 p-4">
                      <div><strong>Name:</strong></div>
                      <div>{sliderOrder.driver_info.name}</div>
                    </td>
                  </tr>
                )}
                {sliderOrder.driver_info.phone_number && (
                  <tr>
                    <td></td>
                    <td className="border border-slate-300 p-4">
                      <div><strong>Phone:</strong></div>
                      <div>{sliderOrder.driver_info.phone_number}</div>
                    </td>
                  </tr>
                )}
              </>
            )}
          </>
        )}
      </table>
    </div>
  );
};

export default ClaimInfo;
